export const GET_DESTINATIONS = "getDestinations";
export const GET_ERROR = "getError";
export const IS_EMPTY = "isEmpty";
